var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.1C3 3.76863 3.26863 3.5 3.6 3.5H5.13606C5.30424 3.5 5.46471 3.57059 5.57835 3.69457L6.32165 4.50543C6.43529 4.62941 6.59576 4.7 6.76394 4.7H12.4C12.7314 4.7 13 4.96863 13 5.3V11.9C13 12.2314 12.7314 12.5 12.4 12.5H3.6C3.26863 12.5 3 12.2314 3 11.9V4.1Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.b4d2b4a442b23d98c31bb9609ea45c03.svg";
export { ForwardRef as ReactComponent };